import React from "react"

const ProjectDetailsDataProject = ({ data }) => {
    return (
        <section className="sc-projectDetials-data d-none">
            <div id="clusterCode" data-cluster={data?.clusterCode} />
            <div id="leadSourceName" data-leadSource={data?.leadSourceName} />
            <div id="projectCode" data-project={data?.projectCode} />
        </section>
    )
}

export default ProjectDetailsDataProject